import { Injectable, signal } from '@angular/core';

import type { RealtimeConnectionState } from './realtime-state.model';

@Injectable({ providedIn: 'root' })
export class RealtimeStatusService {
  private readonly stateValue = signal<RealtimeConnectionState>('disabled');

  readonly state = this.stateValue.asReadonly();

  transitionTo(state: RealtimeConnectionState): void {
    if (state !== this.stateValue()) this.stateValue.set(state);
  }
}